import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
export var CrmLogoIcon = function CrmLogoIcon(props) {
  var _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 38 38' : _props$viewBox,
      _props$width = props.width,
      width = _props$width === void 0 ? '24px' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? '24px' : _props$height;
  var classes = useStyles(props);
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: width,
      height: height,
      viewBox: viewBox
    },
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M18.75,2.48689958e-14 C29.1066217,2.48689958e-14 37.5,8.39508847 37.5,18.75 C37.5,29.1049115 29.1066217,37.5 18.75,37.5 C8.39508847,37.5 2.48689958e-14,29.1049115 2.48689958e-14,18.75 C2.48689958e-14,8.39508847 8.39508847,2.48689958e-14 18.75,2.48689958e-14 Z M29.6555773,26.4695823 L21.587126,26.4695823 C21.587126,28.0736957 22.9398486,29.5102152 24.4977882,30.3635762 C26.5414082,29.4743023 28.3079852,28.1318406 29.6555773,26.4695823 Z M32.391976,19.5730915 L14.987858,19.5730915 C14.987858,22.1707976 18.25765,24.291374 22.319238,24.291374 L31.0751665,24.291374 C31.8173682,22.8463038 32.2773965,21.2558715 32.391976,19.5730915 Z M30.8094103,12.692676 L8.38773486,12.692676 C8.38773486,15.2903822 11.671208,17.3955673 15.7191148,17.3955673 L32.3587993,17.3955673 C32.1689735,15.7076569 31.6285685,14.1189347 30.8094103,12.692676 Z"
    }))
  );
};
var useStyles = makeStyles(function (theme) {
  return {
    cls1: function cls1(props) {
      return {
        fill: props.color ? props.color : theme.palette.product.crm,
        fillRule: 'evenodd'
      };
    }
  };
});